import React from 'react'
import {Link} from 'react-router-dom'
import './styles.css'
import logo from './NamesAndFaces.svg'

const MainLogo = ({absolute = false, style}) => {
    if (absolute) {
        return (
            <h2 className="title-logo" style={style}>
                <a href="https://www.namesandfaces.com">
                    <img src={logo} alt="Names &amp; Faces"/>
                </a>
            </h2>
        )
    }

    return (
        <h2 className="title-logo">
            <Link to="/">
                <img src={logo} alt="Names &amp; Faces"/>
            </Link>
        </h2>
    )
}

export default MainLogo
